import React from "react";
import Linkify from 'react-linkify';
import styles from "./Comments.module.scss";


export interface ISellerCommentsProps {
  description?: string;
}


const Comments = ({description}: ISellerCommentsProps) => {
  const desc = (description || '').trim();
  return desc && (
    <div className={styles.additionalServices}>
      <Linkify>{description}</Linkify>
    </div>
  );
}

Comments.defaultProps = {
  description: "",
};

export default Comments;
